module.exports = __webpack_public_path__ + "static/img/pcga_imp.3bd8a63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga_imp.png
// module id = GrUO
// module chunks = 1